import PostForm from "./post-form";

export default PostForm;